<template>
  <svg aria-hidden="true" width="32" height="32" viewBox="-2 -1 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="15.5" stroke="#6E6F74" />
    <path d="M15.1289 21.6367H16.8789V11.8711H20.418V10.3633H11.582V11.8711H15.1289V21.6367Z" fill="#6E6F74" />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'DayTokenT',
};
</script>
